import styles from "../../../styles/charts/chartStyle.module.css";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { titleStyler, toShortNumber } from "../../../lib/util";

interface BarChartProps {
  xLabel?: string;
  yLabel: string;
  title?: string;
  chartData: any[];
  legend?: string[];
  numberOfColumns?: number;
  categories?: any[];
  isDollar?: boolean;
  loading: boolean;
}

const BarChart = (props: BarChartProps) => {
  const {
    xLabel,
    yLabel,
    title = "Chart Title",
    chartData,
    numberOfColumns = 1,
    legend = [],
    categories = [],
    isDollar = false,
    loading = true,
  } = props;

  let series: any[] = [];

  let { axisTitleStyle } = titleStyler();

  if (numberOfColumns > 1) {
    chartData.forEach((item, index) => {
      series.push({
        name: legend[index],
        type: "bar",
        data: item,
      });
    });
  } else {
    series.push({
      name: "bar",
      type: "bar",
      data: chartData,
    });
  }
  let options = {
    chart: {
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: xLabel,
            headerValue: yLabel,
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
          },
        },
      },

      // zoom: {
      //   enabled: false,
      // },
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    tooltip: {
      y: {
        // show: false,
        title: {
          show: false,
          formatter(seriesName: any) {
            // console.log(seriesName);
            return seriesName === "bar" ? null : seriesName;
          },
        },
        formatter: (value: any) => {
          // console.log(value);
          return isDollar
            ? `$${toShortNumber(value)}`
            : `${toShortNumber(value)}`;
        },
      },
    },
    xaxis: {
      type: "category",
      categories: categories,
      tickPlacement: "on",
      labels: {
        show: true,
        trim: true,
        hideOverlappingLabels: false,
        rotate: 0, //-30
      },
      title: {
        text: props.xLabel,
        offsetX: 0,
        offsetY: 85,
        style: axisTitleStyle,
      },
    },
    yaxis: {
      labels: {
        show: true,
        trim: true,
        hideOverlappingLabels: false,
        rotate: 0,
        formatter: toShortNumber,
      },
      title: {
        text: yLabel,
        offsetY: 0,
        offsetX: 5,
        style: axisTitleStyle,
      },
    },
    colors: [
      "#008FFB",
      "#01E396",
      "#FEB019",
      "#FF4560",
      "#775DD0",
      // "#3b81f1",
      "#ccccff",
      "#7fdfff",
      "#81a432",
      "#68228b",
      "#00563f",
      "#674937",
      "#621b18",
      "#68228b",
    ],
    noData: {
      text: `${loading ? "Loading..." : "Select Atleast One Category"}`,
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
  };

  return (
    <>
      <div style={{ height: "100%" }}>
        <ReactApexChart
          className={styles.the_chart}
          series={series}
          options={options as ApexOptions}
          type="bar"
        />
      </div>
    </>
  );
};

export default BarChart;
